function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.001,
    height: 64,
    viewBox: "0 0 64.001 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17785"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8421",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17782"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59296",
    d: "M73.192 124.09c3-3.7 13.04-18.279 13.04-18.871V82.564a6.591 6.591 0 0 0-6.581-6.584H36.842a6.593 6.593 0 0 0-6.582 6.584v36.975a6.581 6.581 0 0 0 6.581 6.581h35.415a1.231 1.231 0 0 0 .936-2.03z",
    transform: "translate(-30.26 -69.696)",
    style: {
      fill: "#1d1d1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59297",
    d: "M94.676 115.067V92.794a4.813 4.813 0 0 0-4.8-4.8H47.064a4.815 4.815 0 0 0-4.8 4.806v36.973a4.805 4.805 0 0 0 4.8 4.8h34.227l-.191-.224.933-1.15c.93-1.145 1.812-2.367 2.679-3.561q1.851-2.553 3.649-5.145a357.25 357.25 0 0 0 4.284-6.271c.5-.756 1-1.514 1.489-2.281.164-.261.378-.579.542-.874z",
    transform: "translate(-40.482 -79.926)",
    style: {
      fillRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59298",
    d: "M86.232 87.583v-5.019a6.591 6.591 0 0 0-6.581-6.584H36.842a6.593 6.593 0 0 0-6.582 6.584v5.019z",
    transform: "translate(-30.26 -69.696)",
    style: {
      fill: "#1d1d1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59299",
    d: "M81.422 205.6h-6.181a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.233 1.233 0 0 1-1.232 1.231zm34.364-21.018H109.6a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.231 1.231 0 0 1-1.227 1.233zm-11.455 0h-6.182a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.231 1.231 0 0 1-1.231 1.233zm-11.453 0H86.7a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.229h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.231 1.231 0 0 1-1.235 1.231zm-11.456 0h-6.181a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.233 1.233 0 0 1-1.232 1.233zm0 10.508h-6.181a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.233 1.233 0 0 1-1.232 1.234zm11.456 0H86.7a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.231 1.231 0 0 1-1.235 1.234zm11.453 0h-6.182a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.231 1.231 0 0 1-1.231 1.234zM92.878 205.6H86.7a1.231 1.231 0 0 1-1.231-1.231v-6.182a1.231 1.231 0 0 1 1.231-1.231h6.182a1.231 1.231 0 0 1 1.231 1.231v6.182a1.231 1.231 0 0 1-1.235 1.231z",
    transform: "translate(-67.529 -154.847)",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17781"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59300",
    d: "M116.192 55.041a1.231 1.231 0 0 0-2.462 0v6.57a1.231 1.231 0 1 0 2.462 0z",
    transform: "translate(-101.364 -50.81)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59301",
    d: "M213.312 55.041a1.231 1.231 0 0 0-2.462 0v6.57a1.231 1.231 0 1 0 2.462 0z",
    transform: "translate(-184.096 -50.81)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59302",
    d: "M310.432 55.041a1.231 1.231 0 1 0-2.462 0v6.57a1.231 1.231 0 1 0 2.462 0z",
    transform: "translate(-266.828 -50.81)",
    style: {
      fill: "#00de9d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17784"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59303",
    d: "M296.26 260.39a13.283 13.283 0 1 1-9.39 3.89 13.233 13.233 0 0 1 9.39-3.89z",
    transform: "translate(-245.54 -226.786)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59304",
    d: "M307.939 274.1a11.249 11.249 0 1 0 7.954 3.295 11.206 11.206 0 0 0-7.954-3.295z",
    transform: "translate(-257.219 -238.465)",
    style: {
      fill: "#02b782",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59308",
    d: "M302.016 279.087a11.254 11.254 0 0 1 14.084-1.48 10.286 10.286 0 0 0-.207-.212 11.249 11.249 0 1 0-14.084 17.388 11.25 11.25 0 0 1 .207-15.7z",
    transform: "translate(-257.219 -238.465)",
    style: {
      fill: "#04a274",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59309",
    d: "M80.383 2.719a.265.265 0 0 0-.2-.077h-1.454a2.95 2.95 0 0 0-.546-1.227h1.987a.262.262 0 0 0 .273-.273V.273A.262.262 0 0 0 80.17 0h-7.091a.262.262 0 0 0-.273.273v1.133a.277.277 0 0 0 .273.273h1.236q1.8 0 2.284.963h-3.52a.262.262 0 0 0-.273.273v.869a.262.262 0 0 0 .273.273h3.639a1.665 1.665 0 0 1-.874 1.065 3.846 3.846 0 0 1-1.811.367h-.955a.277.277 0 0 0-.273.273v1.082a.255.255 0 0 0 .077.188q1.637 1.738 4.245 4.868a.251.251 0 0 0 .213.1H79a.247.247 0 0 0 .247-.153.233.233 0 0 0-.034-.29Q76.727 8.506 75.3 6.989a4.322 4.322 0 0 0 2.352-.937 3.186 3.186 0 0 0 1.1-1.994h1.432a.263.263 0 0 0 .273-.273v-.87a.265.265 0 0 0-.074-.196z",
    transform: "translate(-25.549 40.884)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.9e33aaf5c095bf4e3a04e627533ca461.svg";
export { ForwardRef as ReactComponent };